import React from 'react'
import SignIn from './components/SingIn';
import FormDialog from './components/FormDialog'

import { useSelector, useDispatch } from 'react-redux'
import autenticador from '../../serviceAPI/autenticador'
import AtivacaoConta from '../../components/AtivacaoConta'

function Login() {
  const dispatch = useDispatch();

  const [openRecuperarSenha, setOpenRecuperarSenha] = React.useState(false);
  const openErroAuth = useSelector(state => state.login.open_erro_auth)

  const openDialogRecuperarSenha = () => {
    setOpenRecuperarSenha(true);
  };

  const closeRecuperarSenha = () => {
    setOpenRecuperarSenha(false);
  };

  async function autenticar(email, senha) {
    await autenticador(email, senha, dispatch);
  }

  return (
    <div>
      <SignIn
        onSubmit={autenticar}
        erroAuth={openErroAuth}
        openDialogRecuperarSenha={openDialogRecuperarSenha}
      />
      <FormDialog
        open={openRecuperarSenha}
        close={closeRecuperarSenha}
      />
      <AtivacaoConta />
    </div>
  )

}

export default Login;